import jQuery from "jquery"
import Vue from "vue"
import VueRouter from "vue-router"
import VueCookie from "vue-cookie"
import VueMq from "vue-mq"
import Chart from "chart.js"
import Clipboard from "v-clipboard"

import moment from "moment"
import numeral from "numeral"

import Vuikit from "vuikit" /// DELETE

import router from "./router"
import store from "./store"

import "./assets/less/uikit.less" // Import your global Less file
import App from "./components/App.vue"

require("moment-weekday-calc")

window.$ = jQuery

Chart.defaults.global.defaultFontFamily = "\"Helvetica Neue\", Helvetica, Arial, \"sans-serif\""
Chart.defaults.global.defaultFontSize = 14
Chart.defaults.global.color = "#00274F"
Chart.defaults.global.animation.duration = 0

Vue.use(VueRouter)
Vue.use(VueCookie)
Vue.use(VueMq, {
    breakpoints: {
        sm: 480,
        md: 900,
        lg: 1280,
        xl: 1440
    }
})
Vue.use(require("vue-shortkey"))
Vue.use(Clipboard)

Vue.use(Vuikit) /// DELETE

require("./i18n.js")

moment.locale("en")
Vue.prototype.$moment = moment

numeral.locale("en")
Vue.prototype.$numeral = numeral

const notifies = {
    methods: {
        $notify (message, type = "primary", dismiss_after = 7000, message_id = null) {
            this.$store.dispatch("SYSTEM_MESSAGE", {
                type,
                message,
                dismiss_after,
                message_id
            })
        },
        $error (message, dismiss_after = 7000, message_id = null) {
            this.$notify(message, "danger", dismiss_after, message_id)
        },
        $warn (message, dismiss_after = 7000, message_id = null) {
            this.$notify(message, "warning", dismiss_after, message_id)
        },
        $success (message, dismiss_after = 7000, message_id = null) {
            this.$notify(message, "success", dismiss_after, message_id)
        }
    }
}
Vue.mixin(notifies)
const confirms = {
    methods: {
        $confirm (props, id = true) {
            this.$store.dispatch("CONFIRM", { confirming: id, props })
        }
    }
}
Vue.mixin(confirms)

if(process.env.NODE_ENV === "development") {
    Vue.config.debug = true
    Vue.config.devtools = true
}

// === FILTERS: v-bind=""I\"m good" | nibnut.slugify" OR {{ "I\"m good" | nibnut.slugify }} OR this.nibnut_filter("nibnut.slugify", ["I"m good"])
Vue.mixin({
    methods: {
        nibnut_filter (filter_name, filter_arguments) {
            return this.$options.filters[filter_name].apply(this, filter_arguments)
        }
    }
})
Vue.filter("nibnut.date_from_now", (date, format = "") => {
    if(!date) return ""
    date = moment(date)
    if(!!format && (moment().diff(date, "days") >= 1)) return date.format(format)
    return date.fromNow()
})
Vue.filter("nibnut.date", (date, format = "MMMM DD, YYYY", empty = "(no date)") => {
    if(!date) return empty
    return moment(date).format(format)
})
Vue.filter("nibnut.number", (number, format = "0,0.0", default_value = null) => {
    if(!number && default_value) return default_value
    return numeral(number).format(format)
})
Vue.filter("nibnut.phone", (phone, lax = false) => {
    if(!phone) return ""
    const matches = phone.replace(/[^\d]+/g, "").match(/^(\d{3})(\d{3})(\d{4})$/)
    if(matches) return `(${matches[1]}) ${matches[2]}-${matches[3]}`
    return lax ? phone : ""
})
Vue.filter("nibnut.mailto", (email) => {
    if(!email) return ""
    return "mailto:" + email
})
Vue.filter("nibnut.telto", (phone) => {
    if(!phone) return ""
    return "tel:" + phone
})
Vue.filter("nibnut.ucwords", (text) => {
    if(!text) return text
    return text.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter) => {
        return letter.toUpperCase()
    })
})
Vue.filter("nibnut.ucfirst", (text) => {
    if(!text) return text
    return text.charAt(0).toUpperCase() + text.slice(1)
})
Vue.filter("nibnut.concat", (components, delimiter = " ") => {
    if(!components) return ""
    return components.filter(component => !!component).join(delimiter)
})
Vue.filter("nibnut.smart-truncate", (text, max_length, ellipsis = "...") => {
    if(!text) return ""
    const length = text.length
    if(length <= max_length) return text
    return text.substring(0, max_length - ellipsis.length) + ellipsis
})
Vue.filter("lam.project-number", (number) => {
    if(number) {
        let standardized_number = number.replace(/^z/, "")
        if(standardized_number.match(/^0/)) standardized_number = standardized_number.replace(/0(\d+?)(\d{2})$/, "$1.$2")
        else if(standardized_number.length > 5) standardized_number = standardized_number.substr(2)
        return standardized_number
    }
})
Vue.filter("lam.percent", (numerator, denominator, format = "0,0") => {
    let percentage = 0
    if(denominator) percentage = (numerator / denominator) * 100
    return numeral(percentage).format(format)
})

Vue.directive("nibnut-on-scroll", {
    inserted: (element, binding) => {
        element = (binding && binding.arg && (binding.arg === "global")) ? window : element
        const listener = (event) => {
            if(binding && !!binding.value && binding.value(event, element)) element.removeEventListener("scroll", listener)
        }
        element.addEventListener("scroll", listener)
    }
})

window.lam_app = new Vue({
    el: "#app",
    store,
    router,
    data: {
        applicationRootURL: window.nibnut.vue.application_url,
        applicationName: window.nibnut.vue.application_name,
        applicationFullName: window.nibnut.vue.application_full_name,
        applicationOfficialName: window.nibnut.vue.application_official_name,
        applicationImages: window.nibnut.vue.application_images_url,
        applicationLogo: window.nibnut.vue.application_logo,
        applicationSettings: window.nibnut.vue.application_settings,
        constants: window.nibnut.vue.constants
    },
    render: h => h(App)
})
